<template>
  <div>
    <div class="row">
      <div class="small-12 medium-4 large-3 columns">
        <label>Employer type <help-icon place="top-right" message="Queensland Government refers to Queensland Government and related entity employees."></help-icon></label>
      </div>

      <div class="small-12 medium-8 large-7 columns text-right">
        <checkbox name="member-type" :items="employerTypes" :selected="EmployerType" @change="setEmployerType($event.value)"></checkbox>
      </div>

      <div class="show-for-large large-2 columns"></div>
    </div>

    <div class="row" v-if="isGovernmentWorker">
      <div class="small-12 medium-4 columns">
        <label>Member contributions <help-icon place="bottom-right" message="Use the slider to change your contribution rate. We’ve put it at 5% because that's what most QLD Gov employees contribute. But police officers often choose 6%. Note: If you work for a QLD Government employer, our calculator may overestimate your benefit as the member contributions are usually worked out on your base salary which doesn't include shift loading and allowances. Check the calculator limitations for more details." :is-error="inferred.MemberContributions.value === 0.06" error-message="Please note: 6% is only available for police officers."></help-icon></label>
      </div>

      <div class="medium-4 columns">
        <slider :percent="true" :property="MemberContributions" :snap="true" @update="setMemberContributions($event.values[0])"></slider>
      </div>

      <div class="small-12 medium-2 columns">
        <select @change="setPostTaxContributions($event.target.value)">
          <option value="true" :selected="PostTaxContributions.value">After tax</option>
          <option value="false" :selected="!PostTaxContributions.value">Before tax</option>
        </select>
      </div>

      <div class="small-12 medium-2 columns">
        <custom-input type="number" filter="percent" :percent="true" :property="MemberContributions" @change="setMemberContributions($event.target.value)"></custom-input>
      </div>
    </div>

    <div class="row" v-if="isNotSelfEmployed">
      <div class="small-12 medium-4 columns">
        <label>Employer contributions <help-icon place="bottom-right" :message="EmployerContributionsMessage" v-if="EmployerContributionsMessage"></help-icon></label>
      </div>

      <div class="medium-6 columns">
        <slider :percent="true" :property="EmployerContributionRate" @update="setEmployerContributionRate($event.values[0])"></slider>
      </div>

      <div class="small-12 medium-2 columns">
        <custom-input :percent="true" filter="percent" :property="EmployerContributionRate" @change="setEmployerContributionRate($event.target.value)"></custom-input>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import { EmployerType } from '@/constants';
import { sendGAView } from '@/store/helpers';
import bus from '@/events';

export default {
  props: {
    modifier: {
      type: String,
      default: '',
    },
  },
  watch: {
    'EmployerType.value': function employerFunc(value) {
      bus.$emit('resize');

      sendGAView({
        hitType: 'event',
        eventCategory: 'EmployerType',
        eventAction: 'click',
        eventLabel: _.find(_.keys(EmployerType), type => EmployerType[type] === value),
      });
    },
  },
  data() {
    return {
      employerTypes: {
        government: {
          value: EmployerType.GOVERNMENT,
          icon: require('!html-loader!@/assets/government.svg'),
          text: 'Queensland Government',
        },
        nonGovernment: {
          value: EmployerType.NON_GOVERNMENT,
          icon: require('!html-loader!@/assets/non-government.svg'),
          text: 'Non Government',
        },
        selfEmployed: {
          value: EmployerType.SELF_OR_NOT_EMPLOYED,
          icon: require('!html-loader!@/assets/self-employed.svg'),
          text: 'Self / Not employed',
        },
      },
    };
  },
  computed: {
    ...mapState(['inputs', 'inferred']),
    EmployerType() {
      return this.inferred[`EmployerType${this.modifier}`];
    },
    MemberContributions() {
      return this.inferred[`MemberContributions${this.modifier}`];
    },
    PostTaxContributions() {
      return this.inputs[`PostTaxContributions${this.modifier}`];
    },
    EmployerContributionRate() {
      return this.inferred[`EmployerContributionRate${this.modifier}`];
    },
    EmployerContributionsMessage() {
      const employerType = this.EmployerType.value;

      switch (employerType) {
        case 1:
          return 'The usual employer contribution for core Queensland Government employees is 12.75% (or 18% for police). If your rate is different, use the slider to update it.';
        case 2:
          return 'Your employer contributions rate has been defaulted to the superannuation guarantee rate. If your employer contributes at a higher rate, change the rate using the slider.';
        default:
          return '';
      }
    },
    isGovernmentWorker() {
      return this.EmployerType.value === EmployerType.GOVERNMENT;
    },
    isNotSelfEmployed() {
      return this.EmployerType.value !== EmployerType.SELF_OR_NOT_EMPLOYED;
    },
  },
  methods: {
    ...mapActions([
      'actionEmployerType',
      'actionMemberContributions',
      'actionPostTaxContributions',
      'actionEmployerContributionRate',
    ]),
    setEmployerType(value) {
      this.actionEmployerType({ value, modifier: this.modifier });
    },
    setMemberContributions(value) {
      this.actionMemberContributions({ value, modifier: this.modifier });
    },
    setPostTaxContributions(value) {
      this.actionPostTaxContributions({ value, modifier: this.modifier });
    },
    setEmployerContributionRate(value) {
      this.actionEmployerContributionRate({ value, modifier: this.modifier });
    },
  },
};
</script>
